import Typography from "@material-ui/core/Typography";
import { Paper } from "@mui/material";
import React, { useState } from "react";
import { ScrollMenu } from "react-horizontal-scrolling-menu";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { getPublicPrice } from "../../utils/weightUtils";
import ProductAddToBasket from "../products/ProductAddToBasket";
import "./Home.scss";

const ConnectedItem = connect(mapStateToProps)(Item);

function HorizontalScroll(props) {
	const [selected, setSelected] = useState([]);
	const [position, setPosition] = useState(0);
	const { data, title } = props;
	const isItemSelected = (id) => !!selected.find((el) => el === id);

	return (
		<div>
			<h2 style={{ marginBottom: 0 }}>{title}</h2>

			<ScrollMenu>
				{data !== ""
					? data?.map((item, i) => <ConnectedItem key={i} item={item} />)
					: null}
			</ScrollMenu>
		</div>
	);
}

function Item(props) {
	return (
		<Paper className="HorizontalScrollCard">
			<div>
				<Link
					style={{ textDecoration: "none" }}
					to={{
						pathname: "/productinfo",
						state: { from: props.item.id },
					}}
				>
					{props.item.image ? (
						<img className="horizontalPhoto" src={props.item.image}></img>
					) : null}
				</Link>
				<div className="textAndButtonHorizontalScroll">
					<Link
						style={{ textDecoration: "none" }}
						to={{
							pathname: "/productinfo",
							state: { from: props.item.id },
						}}
					>
						{props.item.bio ? (
							<div>
								<p className="productName">{props.item.name}</p>{" "}
								<img
									className="bio"
									src={
										"https://www.goeieete.nl/wp-content/themes/goeieete/assets/logo-bio.svg"
									}
								/>
							</div>
						) : (
							<p className="productName">{props.item.name}</p>
						)}
					</Link>

					<div style={{ width: "200px" }}>
						<Typography
							component="span"
							variant="body2"
							className="inline"
							color="textPrimary"
						>
							{getPublicPrice(props.item)}
						</Typography>
					</div>

					<Link
						style={{ textDecoration: "none" }}
						to={{
							pathname: "/supplierinfo",
							state: { from: props.item.supplier_id },
						}}
					>
						<p1 className="supplierNameHorizontalScroll">
							{props.item.supplier_name}
						</p1>
					</Link>
					{props.loginSuccesful ? (
						<div className="AddBasketButtonNameHorizontalScroll">
							<ProductAddToBasket
								productId={props.item.id}
								rowData={props.item}
								screenType="Assortiment"
							/>
						</div>
					) : null}
				</div>
			</div>
		</Paper>
	);
}

function mapStateToProps(state) {
	return {
		loginSuccesful: state.login.data.loginSuccesful,
		identifyInfo: state.identify.identifyInfo,
	};
}

export default connect(mapStateToProps, {})(HorizontalScroll);
